/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const mothers_nourishment : {[key: string]: Array<[string, string]>} = {
};
